<div class="detail-page" [class.batch-selection-active]="selectedCount() > 0">
  <div class="project-sticky-header">

  <!-- Topbar -->
  <div class="detail-topbar">
    <button class="btn-back" (click)="back.emit()" aria-label="Retour au portefeuille">‹&nbsp; Retour au portefeuille</button>
    <div class="topbar-actions">
      <button class="btn-icon" (click)="ciuViewOpen.set(true)">Vue CIU</button>
      <button class="btn-icon follow" (click)="follow()" [disabled]="followBusy()">
        {{ project.followed ? '★ Projet suivi' : '☆ Suivre ce projet' }}
      </button>
      <button class="btn-icon" (click)="openEdit()">✎ Modifier la fiche</button>
      <button class="btn-icon" (click)="openReferenceChange()">⌁ Changer de référentiel</button>
      <button class="btn-icon danger" *ngIf="!project.archived && ['Complété','Annulé'].includes(project.lifecycle)"
        (click)="archiveConfirmOpen.set(true)">Archiver</button>
      <button class="btn-icon" *ngIf="project.archived"
        (click)="archive(false)">Restaurer</button>
      <button class="btn-icon danger" (click)="deleteConfirmOpen.set(true)">Supprimer</button>
    </div>
  </div>

  <!-- Project header -->
  <div class="detail-header">
    <div class="detail-meta">
      <span class="rtbs-tag" [style.border-left-color]="project.accent" *ngIf="project.rtbs">{{ project.rtbs }}</span>
      <span class="framework-tag" *ngIf="project.portfolioNumber">N° de Portfolio : {{ project.portfolioNumber }}</span>
      <span class="framework-tag">{{ project.framework }}</span>
      <span class="phase-tag">{{ project.phase }}</span>
      <span *ngIf="project.isConfidential" class="confidential-tag">🔒 Confidentiel</span>
      <span *ngIf="project.archived" class="archive-tag">Archivé</span>
    </div>
    <h1 class="detail-title">{{ project.title }}</h1>
    <div class="detail-info">
      <span>{{ project.site || 'Non spécifiée' }}</span><span>·</span>
      <span>Responsable : {{ project.manager || 'Non assigné' }}</span><span>·</span>
    </div>
  </div>
  </div>

  <!-- Stats bar -->
  <div class="stats-bar">
    <div class="progress-donut" [style.--progress]="currentPhaseStat().progress + '%'">
      <span>{{ currentPhaseStat().progress }}%</span><small>{{ project.phase }}</small>
    </div>
    <div class="stat current-phase"><span class="stat-label">Phase actuelle</span><strong>{{ currentPhaseStat().completed }} <small>/ {{ currentPhaseStat().applicable }}</small></strong><p>livrables complétés dans {{ project.phase }}</p></div>
    <div class="stat"><span class="stat-label">Obligatoires</span><strong>{{ mandatoryCompletedCount() }} <small>/ {{ mandatoryCount() }}</small></strong><p>obligatoires complétés</p></div>
    <div class="stat"><span class="stat-label">À traiter</span><strong class="danger">{{ pendingCount() }}</strong><p>dont {{ blockedCount() }} en problème</p></div>
    <button class="more-actions" aria-label="Plus d'actions">•••</button>
  </div>

  <div class="checklist-sticky-header">
    <!-- Checklist toolbar -->
    <div class="checklist-toolbar">
    <div class="phase-tabs">
      <button class="phase-tab" [class.active]="activePhase() === 'Tous'" (click)="selectPhase('Tous')"><b>{{ checklistGroups().length }}</b> Tous</button>
      <button class="phase-tab" *ngFor="let stat of phaseStats()"
        [class.active]="activePhase() === stat.phase"
        [class.not-applicable]="stat.allNotApplicable"
        [class.complete]="!stat.allNotApplicable && stat.progress === 100"
        [class.incomplete]="isPreviousPhaseIncomplete(stat.phase)"
        [class.current]="stat.phase === project.phase"
        (click)="selectPhase(stat.phase)">
        <small class="phase-tab-progress">{{ stat.allNotApplicable ? 'N/A' : stat.progress + '%' }}</small>
        <span class="phase-tab-name">{{ stat.phase }}</span>
        <small class="phase-tab-approval" *ngIf="project.phaseApprovalDates[stat.phase]">
          {{ project.phaseApprovalDates[stat.phase] }}
        </small>
      </button>
    </div>

    </div>

    <!-- Batch update bar -->
  <div class="batch-bar" *ngIf="selectedCount() > 0">
    <span class="batch-count">{{ selectedCount() }} sélectionné{{ selectedCount() > 1 ? 's' : '' }}</span>
    <select [value]="batchStatus()" (change)="batchStatus.set($any($event.target).value)">
      <option>Non commencé</option>
      <option>En cours</option>
      <option>Complété</option>
      <option>En problème</option>
      <option>Non applicable</option>
    </select>
    <input *ngIf="batchStatus() === 'Complété'" type="date" class="date-input"
      [value]="batchDate()" (change)="batchDate.set($any($event.target).value)" />
    <input *ngIf="batchStatus() === 'En problème'" type="date" class="date-input"
      [value]="batchDate()" (change)="batchDate.set($any($event.target).value)"
      aria-label="Date du problème" />
    <select *ngIf="batchStatus() === 'En problème'" class="comment-input" aria-label="Raison du problème"
      [ngModel]="batchProblemReasonId()" (ngModelChange)="batchProblemReasonId.set($event)">
      <option value="">Conserver les raisons existantes</option>
      <option *ngFor="let reason of problemReasons()" [value]="reason.id">{{ reason.name }}</option>
    </select>
    <input type="text" class="comment-input"
      [class.required-comment]="batchRequiresComment() && !batchComment().trim()"
      [attr.aria-invalid]="batchRequiresComment() && !batchComment().trim()"
      [placeholder]="batchRequiresComment() ? 'Commentaire requis pour Non applicable' : 'Commentaire optionnel'"
      [value]="batchComment()" (input)="batchComment.set($any($event.target).value)" />
    <button class="btn-primary small" [disabled]="batchBusy()" (click)="applyBatch()">
      {{ batchBusy() ? '...' : 'Appliquer' }}
    </button>
    <button class="btn-link small" (click)="clearSelection()">Désélectionner</button>
    </div>

    <div class="sticky-list-heading">
      <div><h2>Index des livrables</h2><p>{{ filteredChecklist().length }} éléments dans la sélection</p></div>
      <div class="toolbar-filters">
        <button class="filter-btn" [class.active]="checklistFilter() === 'Applicables'" (click)="setChecklistFilter('Applicables')">Applicables</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Tous'" (click)="setChecklistFilter('Tous')">Tous</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Obligatoires'" (click)="setChecklistFilter('Obligatoires')">Obligatoires</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Incomplets'" (click)="setChecklistFilter('Incomplets')">Incomplets</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Non applicables'" (click)="setChecklistFilter('Non applicables')">Non applicables</button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="checklistLoading()">Chargement de la checklist…</div>

  <div class="ciu-overlay" *ngIf="ciuViewOpen()" (click)="ciuViewOpen.set(false)">
  <section class="ciu-view" role="dialog" aria-modal="true" aria-label="Vue condensée CIU des livrables" (click)="$event.stopPropagation()">
    <header class="ciu-header">
      <div>
        <p class="ciu-kicker">Livrables du projet · Vue CIU</p>
        <h2>{{ project.title }}</h2>
        <p>{{ project.rtbs || 'Sans numéro RTBS' }} · {{ project.site || 'Usine non spécifiée' }}</p>
      </div>
      <div class="ciu-actions">
        <button class="btn-secondary" (click)="printCiuView()">Imprimer / Enregistrer en PDF</button>
        <button class="btn-close" (click)="ciuViewOpen.set(false)" aria-label="Fermer la vue CIU">×</button>
      </div>
    </header>

    <div class="ciu-legend" aria-label="Légende des couleurs">
      <span class="mandatory-incomplete">Obligatoire non complété</span>
      <span class="mandatory-na">Obligatoire non applicable</span>
      <span class="completed">Complété</span>
      <span class="optional-incomplete">Non obligatoire non complété</span>
    </div>

    <div class="ciu-viewport" appCiuFit>
    <div class="ciu-content">
    <div class="ciu-phase" *ngFor="let group of ciuChecklistGroups(); trackBy: trackByPhase" [class.ciu-phase-upcoming]="group.phase !== project.phase">
      <h3><span>{{ ciuPhaseLabel(group.phase) }}</span>{{ group.phase }}</h3>
      <div class="ciu-item ciu-column-headings" aria-hidden="true">
        <span>Livrable</span>
        <span>Type d'activité</span>
        <span>Statut</span>
        <span>Date complétée</span>
        <span>Commentaires</span>
      </div>
      <div *ngFor="let item of group.items; trackBy: trackByChecklistItem" [ngClass]="['ciu-item', ciuStatusClass(item)]">
        <span class="ciu-item-title">{{ item.title }}</span>
        <span class="ciu-item-kind">{{ item.kind }}</span>
        <span class="ciu-item-status">{{ item.status }}</span>
        <span class="ciu-item-date">{{ item.status === 'Complété' ? (item.date || '—') : '—' }}</span>
        <span class="ciu-item-comment">{{ item.comment || '—' }}</span>
      </div>
    </div>
    </div>
    </div>
  </section>
  </div>

  <div class="checklist-layout" *ngIf="!checklistLoading()">
  <!-- Checklist groups -->
  <div class="checklist">
    <div class="checklist-heading">
      <div><h2>Index des livrables</h2><p>{{ filteredChecklist().length }} éléments dans la sélection</p></div>
      <div class="toolbar-filters">
        <button class="filter-btn" [class.active]="checklistFilter() === 'Applicables'" (click)="setChecklistFilter('Applicables')">Applicables</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Tous'" (click)="setChecklistFilter('Tous')">Tous</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Obligatoires'" (click)="setChecklistFilter('Obligatoires')">Obligatoires</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Incomplets'" (click)="setChecklistFilter('Incomplets')">Incomplets</button>
        <button class="filter-btn" [class.active]="checklistFilter() === 'Non applicables'" (click)="setChecklistFilter('Non applicables')">Non applicables</button>
      </div>
    </div>

    <!-- Select all -->
    <div class="select-all-row" *ngIf="filteredChecklist().length > 0">
      <label class="toggle-label">
        <input type="checkbox" [checked]="allSelected()"
          (change)="toggleAll($any($event.target).checked)">
        Tout sélectionner <strong>{{ selectedCount() }} sélectionné{{ selectedCount() > 1 ? 's' : '' }}</strong>
      </label>
    </div>

    <div class="checklist-group" *ngFor="let group of checklistGroups(); trackBy: trackByPhase">
      <div class="group-header" (click)="togglePhase(group.phase)">
        <span class="group-phase"><b>{{ phases.indexOf(group.phase) + 1 }}</b>{{ group.phase }}</span>
        <span class="group-stats"><strong>{{ group.completed }} / {{ group.applicable }}</strong> complétés · {{ group.nonApplicable }} non applicables</span>
        <label class="phase-approval-date" (click)="$event.stopPropagation()">
          <span>Date d’approbation</span>
          <input type="date" [value]="project.phaseApprovalDates[group.phase] || ''"
            [disabled]="phaseApprovalSaving().has(group.phase)"
            [attr.aria-label]="'Date d’approbation — ' + group.phase"
            (change)="updatePhaseApprovalDate(group.phase, $any($event.target).value)" />
        </label>
        <button class="collapse-button" [attr.aria-label]="isPhaseCollapsed(group.phase) ? 'Afficher la phase' : 'Masquer la phase'">{{ isPhaseCollapsed(group.phase) ? '⌄' : '⌃' }}</button>
      </div>

      <ng-container *ngIf="!isPhaseCollapsed(group.phase)">
      <div class="checklist-item" *ngFor="let item of group.items; trackBy: trackByChecklistItem"
        [class.overdue]="isOverdue(item)"
        [class.completed]="item.status === 'Complété'"
        [class.na-with-comment]="item.status === 'Non applicable' && hasComment(item)"
        [class.na-without-comment]="isUnjustifiedNotApplicable(item)">

        <input type="checkbox" class="item-checkbox"
          [checked]="selectedIds().has(item.id)"
          (change)="toggleSelection(item, $any($event.target).checked)"
          [attr.aria-label]="'Sélectionner ' + item.title" />

        <div class="item-body" (click)="selectDetailItem(item)">
          <div class="item-header-row">
            <span class="item-kind">{{ item.kind }}</span>
            <span class="req-badge" [class]="item.requirement.toLowerCase().replace(' ', '-')">
              {{ item.requirement }}
            </span>
            <span class="status-badge"
              [class.completed]="item.status === 'Complété'"
              [class.blocked]="item.status === 'En problème'"
              [class.not-applicable]="item.status === 'Non applicable'">
              {{ item.status }}
            </span>
            <span class="status-badge not-applicable" *ngIf="!item.isApplicable && item.status === 'Complété'">Non applicable</span>
            <span class="overdue-badge" *ngIf="isOverdue(item)" title="Phase précédente incomplète">⚠ Non complétée</span>
          </div>
          <span class="item-title">{{ item.title }}</span>
          <span class="problem-reason" *ngIf="item.status === 'En problème' && item.problemReason">
            <strong>Problème :</strong> {{ item.problemReason }}
          </span>
        </div>

        <input *ngIf="item.status === 'Complété'" type="date" class="item-date-input"
          [value]="item.date ?? ''" aria-label="Date de réalisation"
          (click)="$event.stopPropagation()"
          (change)="updateCompletionDate(item, $any($event.target).value)" />
        <input *ngIf="item.status === 'En problème'" type="date" class="item-date-input"
          [value]="item.problemDate ?? ''" aria-label="Date du problème"
          (click)="$event.stopPropagation()"
          (change)="updateProblemDate(item, $any($event.target).value)" />

        <div class="status-buttons">
          <button *ngFor="let s of ['Non commencé','En cours','Complété','En problème','Non applicable']"
            class="status-btn"
            [class.active]="item.status === s"
            [class.completed]="s === 'Complété'"
            [class.blocked]="s === 'En problème'"
            [class.not-applicable]="s === 'Non applicable'"
            (click)="setStatus(item, $any(s))"
            [title]="s" [attr.aria-label]="s">
            {{ s === 'Non commencé' ? '○' : s === 'En cours' ? '◑' : s === 'Complété' ? '✓' : s === 'En problème' ? '!' : '⊗' }}
          </button>
        </div>
      </div>
      </ng-container>
    </div>

    <div class="empty-state" *ngIf="filteredChecklist().length === 0">
      Aucun livrable ne correspond aux filtres sélectionnés.
    </div>
  </div>

  <!-- Item detail panel -->
  <aside class="detail-panel" [class.empty]="!detailItem()">
    <ng-container *ngIf="detailItem(); else detailPlaceholder">
    <div class="panel-header">
      <span class="panel-title">Détails du livrable</span>
      <div class="panel-actions">
        <span class="deliverable-help" *ngIf="detailItem()!.helpText">
          <button type="button" class="detail-help-button" (click)="toggleDetailHelp(detailItem()!)"
            [attr.aria-expanded]="detailHelpItemId() === detailItem()!.id" [attr.aria-label]="'Afficher le détail du livrable : ' + detailItem()!.title">
            i<span class="sr-only"> Détail du livrable</span>
          </button>
          <span class="detail-help-popover" *ngIf="detailHelpItemId() === detailItem()!.id" [innerText]="detailItem()!.helpText" role="tooltip"></span>
        </span>
        <button class="btn-close" (click)="closeDetailItem()">✕</button>
      </div>
    </div>
    <div class="panel-body">
      <h3>{{ detailItem()!.title }}</h3>
      <p><strong>Phase :</strong> {{ detailItem()!.phase }}</p>
      <p><strong>Type :</strong> {{ detailItem()!.kind }}</p>
      <p><strong>Exigence :</strong> {{ detailItem()!.requirement }}</p>
      <div class="detail-field">
        <label for="detail-status">Statut</label>
        <select id="detail-status" class="detail-control" [value]="detailItem()!.status"
          (change)="setStatus(detailItem()!, $any($event.target).value)">
          <option>Non commencé</option>
          <option>En cours</option>
          <option>Complété</option>
          <option>En problème</option>
          <option>Non applicable</option>
        </select>
      </div>
      <div class="detail-field" *ngIf="detailItem()!.status === 'Complété'">
        <label for="detail-completion-date">Date de réalisation</label>
        <input id="detail-completion-date" class="detail-control" type="date"
          [value]="detailItem()!.date ?? ''"
          (change)="updateCompletionDate(detailItem()!, $any($event.target).value)" />
        <small>Choisissez la date à laquelle le livrable a été réalisé.</small>
      </div>
      <div class="detail-field" *ngIf="detailItem()!.status === 'En problème'">
        <label for="detail-problem-date">Date du problème</label>
        <input id="detail-problem-date" class="detail-control" type="date"
          [value]="detailItem()!.problemDate ?? ''"
          (change)="updateProblemDate(detailItem()!, $any($event.target).value)" />
        <small>Date à laquelle le livrable est passé en problème.</small>
      </div>
      <div class="detail-field" *ngIf="detailItem()!.status === 'En problème'">
        <label for="detail-problem-reason">Raison du problème</label>
        <select id="detail-problem-reason" class="detail-control"
          [ngModel]="detailItem()!.problemReasonId?.toString() ?? (detailItem()!.problemReason ? 'legacy' : '')"
          (ngModelChange)="updateProblemReason(detailItem()!, $event)">
          <option value="">— Choisir une raison —</option>
          <option *ngIf="!detailItem()!.problemReasonId && detailItem()!.problemReason" value="legacy">
            {{ detailItem()!.problemReason }} (ancienne saisie)
          </option>
          <option *ngFor="let reason of problemReasons()" [value]="reason.id">{{ reason.name }}</option>
        </select>
        <small>Choisissez une cause pour le Pareto. Les précisions peuvent être ajoutées au commentaire.</small>
        <small>La raison est enregistrée dès sa sélection.</small>
      </div>
      <div class="detail-field problem-history"
        *ngIf="detailItem()!.status === 'Complété' && (detailItem()!.problemDate || detailItem()!.problemReason)">
        <label>Historique du problème</label>
        <p *ngIf="detailItem()!.problemDate"><strong>Depuis le :</strong> {{ detailItem()!.problemDate }}</p>
        <p *ngIf="detailItem()!.problemReason"><strong>Raison :</strong> {{ detailItem()!.problemReason }}</p>
      </div>
      <div class="detail-field">
        <label for="detail-comment">Commentaire{{ isUnjustifiedNotApplicable(detailItem()!) ? ' requis' : '' }}</label>
        <textarea id="detail-comment" class="detail-control detail-comment" rows="4"
          [class.required-comment]="isUnjustifiedNotApplicable(detailItem()!)"
          [attr.aria-invalid]="isUnjustifiedNotApplicable(detailItem()!)"
          [placeholder]="isUnjustifiedNotApplicable(detailItem()!) ? 'Expliquez pourquoi ce livrable est non applicable' : 'Ajouter un commentaire'"
          [value]="detailItem()!.comment ?? ''"
          (change)="updateComment(detailItem()!, $any($event.target).value)"></textarea>
        <small *ngIf="isUnjustifiedNotApplicable(detailItem()!)">Un commentaire est requis pour justifier ce statut.</small>
        <small *ngIf="!isUnjustifiedNotApplicable(detailItem()!)">Le commentaire est enregistré lorsque vous quittez le champ.</small>
      </div>
      <a *ngIf="detailItem()!.referenceUrl" [href]="detailItem()!.referenceUrl"
        target="_blank" rel="noopener noreferrer" class="ref-link">
        📎 Ouvrir le template du livrable
      </a>
    </div>
    </ng-container>
    <ng-template #detailPlaceholder><div class="panel-placeholder"><span>☷</span><h3>Détails du livrable</h3><p>Sélectionnez un élément pour consulter son aide, ses liens et son historique.</p></div></ng-template>
  </aside>
  </div>

</div>

<!-- Edit project modal -->
<div class="modal-overlay" *ngIf="editOpen()" (click)="editOpen.set(false)">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Modifier le projet</h2>
      <button class="btn-close" (click)="editOpen.set(false)">✕</button>
    </div>
    <div class="form-grid">
      <div class="form-group form-group--full">
        <label>Titre *</label>
        <input type="text" class="form-input" [value]="editForm().title"
          (input)="setEditTitle($any($event.target).value)" />
      </div>
      <div class="form-group">
        <label>Numéro de Portfolio</label>
        <input type="text" class="form-input" [value]="editForm().portfolioNumber" [readonly]="!!project.portfolioNumber"
          (input)="setEditPortfolioNumber($any($event.target).value)" />
        <small>{{ project.portfolioNumber ? 'Identifiant unique : il ne peut pas être modifié.' : 'À saisir lorsque le numéro est disponible.' }}</small>
      </div>
      <div class="form-group">
        <label>Numéro de projet (RTBS)</label>
        <input type="text" class="form-input" [value]="editForm().rtbs"
          placeholder="P-1234567" (input)="setEditRtbs($any($event.target).value)" />
        <small *ngIf="!project.rtbs">À saisir après le premier passage au CIU.</small>
        <small *ngIf="project.rtbs">Un changement nécessite une confirmation.</small>
      </div>
      <div class="form-group">
        <label>Cadre de projet *</label>
        <select class="form-input" [ngModel]="editForm().framework"
          (ngModelChange)="setEditFramework($event)">
          <option *ngFor="let framework of editFrameworks()" [ngValue]="framework.code">{{ framework.code }} — {{ framework.name || framework.code }}</option>
        </select>
        <small>Les livrables seront ajustés selon le cadre sélectionné.</small>
      </div>
      <div class="form-group">
        <label>Responsable *</label>
        <input type="text" class="form-input" [value]="editForm().manager"
          (input)="setEditManager($any($event.target).value)" />
      </div>
      <div class="form-group">
        <label>Usine</label>
        <select class="form-input" [value]="editForm().site"
          (change)="setEditSite($any($event.target).value)">
          <option *ngFor="let s of sites">{{ s }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Phase courante</label>
        <select class="form-input" [value]="editForm().phase"
          (change)="setEditPhase($any($event.target).value)">
          <option *ngFor="let p of phases">{{ p }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>État</label>
        <select class="form-input" [value]="editForm().lifecycle"
          (change)="setEditLifecycle($any($event.target).value)">
          <option *ngFor="let l of lifecycles">{{ l }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Code de complexité</label>
        <input type="number" class="form-input" step="0.01" min="0.01" max="999.99"
          [value]="editForm().complexityCode"
          (input)="setEditComplexity(+$any($event.target).value)" />
      </div>
    </div>
    <div class="error-message" *ngIf="editError()">{{ editError() }}</div>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="editOpen.set(false)">Annuler</button>
      <button class="btn-primary" [disabled]="saving()" (click)="saveEdit()">
        {{ saving() ? 'Enregistrement...' : 'Enregistrer' }}
      </button>
    </div>
  </div>
</div>

<!-- RTBS change confirm -->
<div class="modal-overlay" *ngIf="rtbsChangeConfirmOpen()" (click)="rtbsChangeConfirmOpen.set(false)">
  <div class="modal-card small" (click)="$event.stopPropagation()">
    <div class="modal-header"><h2>Modifier le numéro RTBS</h2></div>
    <p class="modal-message">Confirmer le remplacement de <strong>{{ project.rtbs }}</strong> par <strong>{{ editForm().rtbs.trim().toUpperCase() }}</strong> ?</p>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="rtbsChangeConfirmOpen.set(false)">Annuler</button>
      <button class="btn-primary" (click)="confirmRtbsChange()">Confirmer</button>
    </div>
  </div>
</div>

<!-- Archive confirm -->
<div class="modal-overlay" *ngIf="archiveConfirmOpen()" (click)="archiveConfirmOpen.set(false)">
  <div class="modal-card small" (click)="$event.stopPropagation()">
    <div class="modal-header"><h2>Archiver le projet</h2></div>
    <p class="modal-message">Confirmer l'archivage de <strong>{{ project.rtbs }}</strong> ?</p>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="archiveConfirmOpen.set(false)">Annuler</button>
      <button class="btn-danger" [disabled]="archiveBusy()" (click)="archive()">
        {{ archiveBusy() ? '...' : 'Archiver' }}
      </button>
    </div>
  </div>
</div>

<!-- Reference change modal -->
<div class="modal-overlay" *ngIf="referenceChangeOpen()" (click)="referenceChangeOpen.set(false)">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Changer le référentiel</h2>
      <button class="btn-close" (click)="referenceChangeOpen.set(false)">✕</button>
    </div>
    <div class="modal-body">
      <p>Sélectionnez la version publiée à appliquer :</p>
      <select class="form-input" [value]="targetVersionId()"
        (change)="targetVersionId.set($any($event.target).value)">
        <option value="">— Choisir une version —</option>
        <option *ngFor="let v of referenceVersions()" [value]="v.id"
          [disabled]="v.status !== 'Published' || v.id === project.templateVersionId">
          v{{ v.versionNumber }} — {{ v.status }}{{ v.id === project.templateVersionId ? ' (actuelle)' : '' }}
        </option>
      </select>
    </div>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="referenceChangeOpen.set(false)">Annuler</button>
      <button class="btn-primary" [disabled]="!targetVersionId() || changingReference()" (click)="changeReference()">
        {{ changingReference() ? 'Migration...' : 'Appliquer' }}
      </button>
    </div>
  </div>
</div>

<!-- Delete confirm -->
<div class="modal-overlay" *ngIf="deleteConfirmOpen()" (click)="deleteConfirmOpen.set(false)">
  <div class="modal-card small" (click)="$event.stopPropagation()">
    <div class="modal-header"><h2>Supprimer le projet</h2></div>
    <p class="modal-message">
      Cette action est <strong>irréversible</strong>. Supprimer
      <strong>{{ project.rtbs }}</strong> et tous ses livrables&nbsp;?
    </p>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="deleteConfirmOpen.set(false)">Annuler</button>
      <button class="btn-danger" [disabled]="deleteBusy()" (click)="deleteProject()">
        {{ deleteBusy() ? 'Suppression...' : 'Supprimer définitivement' }}
      </button>
    </div>
  </div>
</div>

<!-- Toast -->
<div class="toast-bar" *ngIf="toast()">{{ toast() }}</div>
